import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = (token) =>
  axios.create({
    baseURL: API,
    headers: { "X-Admin-Token": token },
  });

export const fetchStores = async () => (await api.get("/stores")).data;
export const fetchNearby = async (lat, lng, radiusKm = 50) =>
  (await api.get("/stores/nearby", { params: { lat, lng, radius_km: radiusKm } })).data;
export const fetchEvents = async (storeId) =>
  (await api.get("/events", { params: storeId ? { store_id: storeId } : {} })).data;
export const fetchVisitCounts = async () =>
  (await api.get("/stores/visits/last30days")).data;
export const recordVisit = async (storeId) => {
  try {
    await api.post(`/stores/${storeId}/visit`);
  } catch (e) {
    // fire-and-forget; don't block UI
  }
};
export const submitRsvp = async (eventId, name, mobile) =>
  (await api.post(`/events/${eventId}/rsvp`, { event_id: eventId, name, mobile })).data;
export const adminLogin = async (password) =>
  (await api.post("/admin/login", { password })).data;
export const seedData = async () => (await api.post("/seed")).data;
